import React from 'react';
import {
  Grid,
  Box,
  Alert,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    maxWidth: 400,
   // padding: theme.spacing(2),
    margin: 'auto',
    textAlign: 'center',
  },
}));

interface CustomEmailActionProps {}

const CustomEmailAction: React.FC<CustomEmailActionProps> = () => {
  const classes = useStyles();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get('mode') ?? ""

  switch (mode) {
    case 'resetPassword':
      // Display email recovery handler and UI.
      return <ResetPassword />
    case 'verifyEmail':
      // Display email verification handler and UI.
      return <VerifyEmail />;
    default:
      // Error: invalid mode.
      return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Box className={classes.message} sx={{ backgroundColor: 'white', padding: 2, borderRadius: 1 }}>
          <Alert severity="error" sx={{ marginBottom: 2 }}>
            {"Unsupported URL"}
          </Alert>
        </Box>
      </Grid>
    </Grid>
  );
    }
};

export default CustomEmailAction;